import { useEffect, useState } from "react";
import type { ApiClient } from "../../api/client";
import type { GeneralResponse, Ride } from "../../api/types";
import { t } from "../../i18n";
import { AppIcon } from "../AppIcon";

/** The problems a courier could report at the door (prototype paneHtml "prob"), as the server knows them. */
export const PROBLEMS = [
  "Klant niet thuis",
  "Adres niet gevonden",
  "Klant weigert bestelling",
  "Andere reden (bel de zaak)",
] as const;

interface Props {
  api: ApiClient;
  ride: Ride;
  report: (error: unknown) => void;
}

/**
 * "⚠" in a window over the rides (Furkan, 18/10/2026): one short question, one button that calls the shop, and
 * at the very bottom the note of the customer in yellow when there is one. Instead of the four buttons that
 * sent a report to the till: a call says more, at once.
 */
export function ProblemPane({ api, ride, report }: Props) {
  const text = t.tafoApp.courier;
  const [phone, setPhone] = useState<string | null>(null);
  useEffect(() => {
    let current = true;
    api
      .request<GeneralResponse>("GET", "/device/general", { retry: true })
      .then((answer) => {
        if (current) setPhone(answer.general.phone.trim() || null);
      })
      .catch(report);
    return () => {
      current = false;
    };
  }, [api, report]);

  const note = ride.note?.trim() ?? "";
  return (
    <div className="ph-problem">
      <p className="ph-askshop">{text.problemAsk}</p>
      {phone !== null ? (
        <a className="ph-callshop" href={`tel:${phone.replace(/[^\d+]/g, "")}`}>
          <span className="ph-callicon" aria-hidden="true">
            <AppIcon name="phone" />
          </span>
          <span className="ph-calltext">
            <b>{text.callShop}</b>
            <small className="num">{phone}</small>
          </span>
        </a>
      ) : (
        <p className="proto c">{text.noShopPhone}</p>
      )}
      {note !== "" && (
        <div className="ph-custnote" role="note">
          <span className="ph-noteicon" aria-hidden="true">
            <AppIcon name="note" size={18} />
          </span>
          <small>{text.customerNote}</small>
          <b>“{note}”</b>
        </div>
      )}
    </div>
  );
}
